"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "@/lib/utils";
import {
  portfolioItems,
  portfolioCategories,
  PortfolioCategory,
} from "@/lib/portfolio";
import { ProjectCard } from "@/components/ui/ProjectCard";

export default function ProjectsList() {
  const tPortfolio = useTranslations("Portfolio");
  const [activeCategory, setActiveCategory] =
    useState<PortfolioCategory>("all");

  const filteredItems =
    activeCategory === "all"
      ? portfolioItems
      : portfolioItems.filter((item) => item.category.includes(activeCategory));

  return (
    <>
      <div className="flex justify-start mb-16 md:mb-20">
        {/* Left align or center? sticking to left for page flow, or center? Portfolio was center. Page has left header. Let's align left to match header info or center for grid? Portfolio section was centered. Let's try Left to match Title. */}
        <div className="inline-flex flex-wrap justify-center gap-1.5 sm:gap-3 p-1.25 sm:p-2.5 rounded-full bg-(--bg-card) border border-(--border-subtle) shadow-sm select-none">
          {portfolioCategories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={cn(
                "relative px-3 sm:px-6 py-1.25 sm:py-2.5 rounded-full text-sm font-bold tracking-wide transition-all duration-300 cursor-pointer",
                activeCategory === category
                  ? "text-(--text-primary)"
                  : "text-(--text-secondary) hover:text-(--brand-primary)",
              )}
            >
              <span className="relative z-10 capitalize">
                {tPortfolio(`filters.${category}`)}
              </span>
              {activeCategory === category && (
                <motion.div
                  layoutId="activeTabPage"
                  className="absolute inset-0 bg-(--bg-primary) rounded-full shadow-sm"
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
            </button>
          ))}
        </div>
      </div>

      <motion.div
        layout
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12"
      >
        <AnimatePresence mode="popLayout">
          {filteredItems.map((item) => (
            <motion.div
              key={item.key}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
            >
              <ProjectCard item={item} />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
    </>
  );
}
